/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mglMap.vue?vue&type=template&id=2184e7f0&scoped=true"
import script from "./mglMap.vue?vue&type=script&lang=js"
export * from "./mglMap.vue?vue&type=script&lang=js"
import style0 from "./mglMap.vue?vue&type=style&index=0&id=2184e7f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2184e7f0",
  null
  
)

export default component.exports